import { TfsContext } from "Presentation/Scripts/TFS/TFS.Host.TfsContext";
import { ActionUrl } from "WorkItemTracking/Scripts/ActionUrls";

/**
 * Gets the URL for the workitem hub
 */
export function getWorkItemHubUrl(): string {
    return TfsContext.getDefault().getActionUrl(null, "workitems");
}

/**
 * Gets the edit URL for the given workitem
 * @param workItemId ID of the workitem for which the edit URL is to be returned
 */
export function getEditWorkItemUrl(workItemId: number): string {
    return `${getWorkItemHubUrl()}/${ActionUrl.ACTION_EDIT}/${workItemId}`;
}
